import { RangeQueryInterface, RangeRelationEnum } from '@sport-activities/sdk';

import { RangeCms } from '~/cms/interfaces/homepage.cms.interface';

export function buildRangeQuery<T>(range: RangeCms<T>): RangeQueryInterface<T> {
  const gte = range?.from ?? undefined; // 0 is a valid value
  const lte = range?.to ?? undefined; // 0 is a valid value
  const relation = range?.exclude_intersection
    ? ('WITHIN' as RangeRelationEnum)
    : ('INTERSECTS' as RangeRelationEnum);

  return gte === undefined && lte === undefined
    ? undefined
    : { gte, lte, relation };
}
